<div class="question-type__text">
  <h1 class="fs__xxl">Input Variable</h1>
  <p class="fs__md">
    Participants enter a single line response. This can be either a text value, a number, a phone number or an email address. Suitable for names, brief
    comments, or short answers.
  </p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">What age are you?</p>
</div>
